import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filters: {
    keeper: [0, 20],
    defending: [0, 20],
    playmaking: [0, 20],
    wing: [0, 20],
    passing: [0, 20],
    scoring: [0, 20],
    setpieces: [0, 20],
    HTMS: [0, 3000],
    age: { years: [17, 36], days: [0, 111] },
  },
  results: [],
}

const allPlayersSlice = createSlice({
  name: 'allPlayers',
  initialState,
  reducers: {
    setAllPlayersFilters(state, action) {
      state.filters = action.payload
    },
    setAllPlayersResults(state, action) {
      state.results = action.payload
    },
    resetAllPlayers() {
      return initialState
    },
  },
})

export const { setAllPlayersFilters, setAllPlayersResults, resetAllPlayers } =
  allPlayersSlice.actions

export default allPlayersSlice.reducer
